import './style';
import App from './components/app';
import './assets/style.css'
//
import 'antd/dist/antd.css';
import 'rsuite/dist/rsuite.min.css';

export default App;
